// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IApplication } from "store/entities/applications";

export enum DropdownOptions {
  Settings = "settings",
  SetupInstructions = "setup-instructions",
  DirectInstallUrl = "direct-install-url",
  ContactDeveloper = "contact-developer",
  Install = "install",
  Uninstall = "uninstall",
  OpenInMarketplace = "open-in-marketplace",
  GoToApp = "go-to-app",
}

export const DropdownOptionsContent: Record<DropdownOptions, string> = {
  [DropdownOptions.Settings]: "Settings",
  [DropdownOptions.SetupInstructions]: "Setup instructions",
  [DropdownOptions.DirectInstallUrl]: "Finish installation",
  [DropdownOptions.ContactDeveloper]: "Contact developer",
  [DropdownOptions.Install]: "Install",
  [DropdownOptions.Uninstall]: "Uninstall",
  [DropdownOptions.OpenInMarketplace]: "Open in Marketplace",
  [DropdownOptions.GoToApp]: "Go to app",
};

export enum DefaultIntegration {
  LiveChat = "livechat",
  Zapier = "zapier",
}

export enum ApplicationsDesignationUrl {
  Standard = "/apps/",
  Private = "/private-apps/",
  InReview = "/in-review-apps/",
}

export enum IntegrationsTab {
  installed = "installed",
  private = "private",
  inReview = "in-review",
  api = "api",
}

export enum LiveChatDataImportType {
  Tickets = "tickets",
  AgentsAndGroups = "agents",
  CannedResponses = "cannedResponses",
  Tags = "tags",
}

export const defaultIntegrations: IApplication[] = [
  {
    id: DefaultIntegration.LiveChat,
    name: "LiveChat",
    description: "Integrate HelpDesk and LiveChat to create a powerful customer support platform.",
    slug: "livechat",
    isService: false,
    icons: {},
    elements: {
      widgets: [],
    },
  },
  {
    id: DefaultIntegration.Zapier,
    name: "Zapier",
    description: "Let customers read articles right inside your chat widget instead of starting a conversation.",
    slug: "zapier",
    isService: false,
    icons: {},
    elements: {
      widgets: [],
    },
  },
];
